import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from "classnames";
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './OrderStatusSkeleton.css'


function OrderStatusSkeleton() {
    return (
        <div className={s.orderStatusSkeletonBox}>
            <Skeleton className={s.orderStatusSkeletonTitle} />
            <div>
                <Skeleton />
                <div>
                    {[1, 2, 3, 4, 5, 6].map((n) => {
                        return (
                            <div className={cx(s.orderStatusSkeletonTrackBox, 'orderStatusTrackBoxRtl')}>
                                <Skeleton className={s.orderStatusSkeletonTrackImg} />
                                <Skeleton className={cx(s.orderStatusSkeletonTrackContent, s[`orderStatusSkeletonTrackContent${n}`])} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default withStyles(s)(OrderStatusSkeleton);
